import React, { useEffect, useState } from "react";
import { Alert, Row, Col, Form, Button } from "reactstrap";

// hooks
import { useRedux } from "../../hooks/index";

// router
import { Link, Navigate } from "react-router-dom";

// validations
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

// hooks
import { useProfile } from "../../hooks";

//actions
import {
  userForgetPassword,
  authForgetPassApiResponseSuccess,
  authForgetPassApiResponseError,
} from "../../redux/actions";

// components
import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import AuthHeader from "../../components/AuthHeader";
import FormInput from "../../components/FormInput";
import Loader from "../../components/Loader";
import { createSelector } from "reselect";

// auth service
import { resetPassword } from "../../services/auth";

interface RecoverPasswordProps {}

const RecoverPassword = (props: RecoverPasswordProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();

  interface ResetPasswordFormValues {
    email: string;
  }

  const errorData = createSelector(
    (state: any) => state.ForgetPassword,
    state => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
      forgetPassLoading: state.loading,
    }),
  );

  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Inside your component
  const { forgetError, forgetSuccessMsg, forgetPassLoading } =
    useAppSelector(errorData);

  const resolver = yupResolver(
    yup.object().shape({
      email: yup
        .string()
        .email("This value should be a valid email.")
        .required("Please Enter E-mail."),
    }),
  );

  const defaultValues: any = {};

  const methods = useForm<ResetPasswordFormValues>({ defaultValues, resolver });
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = methods;

  const onSubmitForm = async (values: ResetPasswordFormValues) => {
    // dispatch(userForgetPassword(values));

    const response = await resetPassword(values.email);
    // If resetPassword is successful, dispatch the success action
    if (response.success) {
      setAlertMessage("Reset Email was sent successfully!");
      setAlertType("success");
    } else {
      setAlertMessage(response.message || "Reset Password was failed.");
      setAlertType("danger");
    }
  };

  const { userProfile, loading } = useProfile();
  if (userProfile && !loading) {
    return <Navigate to={{ pathname: "/dashboard" }} />;
  }

  return (
    <NonAuthLayoutWrapper>
      <Row className=" justify-content-center my-auto">
        <Col sm={8} lg={6} xl={5} className="col-xxl-4">
          <div className="py-md-5 py-4">
            <AuthHeader
              title="Reset Password"
              subtitle="Reset Password with Invoice."
            />

            {alertMessage ? (
              <Alert color={alertType} toggle={() => setAlertMessage("")}>
                {alertMessage}
              </Alert>
            ) : (
              <Alert color="info" className="text-center my-4">
                Enter your Email and instructions will be sent to you!
              </Alert>
            )}

            <Form
              onSubmit={handleSubmit(onSubmitForm)}
              className="position-relative"
            >
              {forgetPassLoading && <Loader />}
              <div className="mb-3">
                <FormInput
                  label="Email"
                  type="text"
                  name="email"
                  register={register}
                  errors={errors}
                  control={control}
                  labelClassName="form-label"
                  placeholder="Enter Email"
                  className="form-control"
                />
              </div>
              <div className="text-center mt-4">
                <Button color="primary" className="w-100" type="submit">
                  Reset
                </Button>
              </div>
            </Form>
            <div className="mt-5 text-center text-muted">
              <p>
                Remember It ?{" "}
                <Link
                  to="/auth-login"
                  className="fw-medium text-decoration-underline"
                >
                  {" "}
                  Login
                </Link>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default RecoverPassword;
